export class IconConstants {
    // using to sanitze URL icon or logo;
    public static readonly typePNG = 'data:image/png;base64';
    public static readonly typeSVG = 'data:image/svg+xml;base64';
}